// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment-old.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
/**
 * The environment variable to be shared accross the application
 */
export const environment = {
  //P&L Component
  PLComponentMenuFundosId: window['env']['PLComponentMenuFundosId'] || '',
  plObject: window['env']['plObject'] || '',
  homePlObject:window['env']['homePlObject'] || '', //WXhQUHT for dev - replaced with cert id for testing on 06/09/2022
  //Accumulado Gestao Home
  HomeAccumuladoGestaoDates:window['env']['HomeAccumuladoGestaoDates'] || '',
  HomeAccumuladoGestaoConsolidated:window['env']['HomeAccumuladoGestaoConsolidated'] || '',
  HomeAccumuladoGestaoTransfer:window['env']['HomeAccumuladoGestaoTransfer'] || '',
  HomeAccumuladoGestaoRebate:window['env']['HomeAccumuladoGestaoRebate'] || '',
  HomeAccumuladoGestaoIncome:window['env']['HomeAccumuladoGestaoIncome'] || '',
  HomeAccumuladoGestaoSelectfund:window['env']['HomeAccumuladoGestaoSelectfund'] || '',
  HomeAccumuladoGestaoTableDetail:window['env']['HomeAccumuladoGestaoTableDetail'] || '',
  //Accumulado Gestao Component
  AccumuladoGestaoSelectFund:window['env']['AccumuladoGestaoSelectFund'] || '',
  AccumuladoGestaoConsolidated:window['env']['AccumuladoGestaoConsolidated'] || '',
  AccumuladoGestaoTransfer:window['env']['AccumuladoGestaoTransfer'] || '',
  AccumuladoGestaoRebate:window['env']['AccumuladoGestaoRebate'] || '',
  AccumuladoGestaoIncome:window['env']['AccumuladoGestaoIncome'] || '',
  idObjRebates:window['env']['idObjRebates'] || '',
  idObjDetails:window['env']['idObjDetails'] || '',
  //Cotas component
  CotasObjectId:window['env']['CotasObjectId'] || '',
  //Fluxo Caixa component
  FluxoCaixaId:window['env']['FluxoCaixaId'] || '',
  FluxoCaixaDataliquidacao:window['env']['FluxoCaixaDataliquidacao'] || '',
  isQlikUat:window['env']['isQlikUat'] || '',


  // palmyra-needle-add-environment-var: Do not delete this line
  // basePath: '/ataouni-314028-app/services/rest',
  basePath: window['env']['basePath'] || '',

  basePathExternal:window['env']['basePathExternal'] || '',
  basePathExternalApi: window['env']['basePathExternalApi'] || '',

  dhPath: window['env']['dhPath'] || '',

  indexadorPah: window['env']['indexadorPah'] || '',


  fundoCotaPath: window['env']['fundoCotaPath'] || '',

  counterPartPath:  window['env']['counterPartPath'] || '',

  lastrotPath:  window['env']['lastrotPath'] || '',


  msalUrl: window['env']['msalUrl'] || '',
  // msalUrl: 'https://s3portal.dev.boletas.internal',

  soap_ticket:  window['env']['soap_ticket'] || '',

  // B2C
  b2cPolicySignIn:  window['env']['b2cPolicySignIn'] || '',

  b2cAuthoritySignIn: window['env']['b2cAuthoritySignIn'] || '',

   b2cPolicyPasswordReset: window['env']['b2cPolicyPasswordReset'] || '',


   b2cAuthorityPasswordReset: window['env']['b2cAuthorityPasswordReset'] || '',


  b2cUserInfoScope: window['env']['b2cUserInfoScope'] || '',

  b2cWebApiScope:window['env']['b2cWebApiScope'] || '',
  b2cChangePassword:window['env']['b2cChangePassword'] || '',
    

  b2cClientId: window['env']['b2cClientId'] || '',
  b2cAuthorityDomain: window['env']['b2cAuthorityDomain'] || '',
  loginSSO : window['env']['loginSSO'],
  isUatOrProd :window['env']['isUatOrProd']  || '',

  //Qlik
  qlikUrl: window['env']['qlikUrl']  || '',
  qlikPort: 443,
  qlikPrefix: window['env']['qlikPrefix']  || '',
  qlikIsSecure: true,
  qlikAppIdPT: window['env']['qlikAppIdPT'] || '',
  qlikAppIdEN: window['env']['qlikAppIdEN'] || '',

  /* Do not write your custom code here, it will be replaced by the generated content */
  // end palmyra-needle-add-environment-var
  prefix:  window['env']['prefix'] || '',
  production: window['env']['production'] || '',
  mockService: [] ,
  showLogs:window['env']['showLogs'] || '',
  useEncrypt: window['env']['useEncrypt'] || '',
  appVersion: window['env']['appVersion'] || '',
}
